import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useFormik} from 'formik';
import {useAuth} from '../../context/AuthContext';
import server from '../../global/server';
import useHandleErrors from '../../hooks/useHandleErrors';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {useNavigate, useSearchParams} from 'react-router-dom';
import logo from '../../assets/logo.png';
import {Box} from '@mui/material';
import {useCookies} from 'react-cookie';
import {sleep} from '../../global/helpers';

const LoginBackoffice = props => {
    const [search] = useSearchParams();
    const {Login, logged} = useAuth();
    const navigation = useNavigate();
    const [hasError, setError] = useState();
    useHandleErrors(hasError);

    const {values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting} =
        useFormik({
            initialValues: {username: 'admin', password: 'adm#123'},
            onSubmit: async (values, {setSubmitting}) => {
                try {
                    setSubmitting(true);
                    await server.get('auth/firstUser');
                    const {data} = await server.post('auth', values);
                    Login(data.data.user, data.data.token)
                    await sleep(3000);
                    //verifySession();
                    navigation('/dashboard');
                    setSubmitting(false);
                } catch (error) {
                    setSubmitting(false);
                    setError(error);
                }
            },
        });

    useEffect(() => {
        if (logged) {
            navigation('/dashboard');
        }
    }, [logged]);

    return (
        <PanelAuth>
            <div>
                <BoxAuth>
                    <form onSubmit={handleSubmit}>
                        <Grid container direction="column" gap={2}>
                            <Grid sx={{textAlign: 'center'}}>
                                <Box
                                    sx={{width: 200, marginBottom: 2}}
                                    component="img"
                                    src={logo}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="Login"
                                    type="text"
                                    name="username"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.username}
                                    //disabled={isOffline}
                                    error={errors.username}
                                    helperText={errors.username}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Senha"
                                    type="password"
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    error={errors.password}
                                    helperText={errors.password}
                                    //disabled={isOffline}
                                />
                            </Grid>

                            <Grid>
                                <LoadingButton
                                    type="submit"
                                    fullWidth
                                    loading={isSubmitting}
                                    variant="contained"
                                    disabled={
                                        !(values.username && values.password) || isSubmitting
                                    }>
                                    Entrar
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </form>
                </BoxAuth>
            </div>
        </PanelAuth>
    );
};

export default LoginBackoffice;

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 0.6rem;
    padding: 2rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;
